import React from 'react';
import { compose } from 'recompose';

import securedPage from '../../securedPage';
import roles from '../../../constants/roles';
import AgenciesTable from '../../settings/AgenciesTable';
import { withPageTitle } from '../../../utils/page-title';

const AgenciesPage = () => <AgenciesTable />;

export default compose(
  withPageTitle(() => 'Paramétrage des zones de vente'),
  securedPage(roles.configuration.view.code),
)(AgenciesPage);
